export const postInformationToDiscord =
  (formData) => async (dispatch, getState) => {
    let userInfo = formData;
    try {
      const pseudoname = "Terafac Contact Us ";
      const url =
        "https://discord.com/api/webhooks/1162713198533820467/bgCCcBUBwJxdDGs46LD0MTXH_9rZRrmwy7O821c3YcCFKVSiqIrGl6jjyY1ZLCLZaGdX";

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: pseudoname,
          content: JSON.stringify(userInfo),
          tts: false,
          color: "white",
        }),
      });
      await response.text();
    } catch (err) {
    }
  };

export const postSummaryToDiscord = async (email) => {
  try {
    const pseudoname = "chatgpt";
    const url =
      "https://discord.com/api/webhooks/1233360222018474036/0tvpmrNS_829AoQh2CdKy5HL-WKkW-Uby2y1uHjilvHJl31kx7z3A4hboaUVPtjdgOVD";

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: pseudoname,
        content: `New newsletter subscription from: ${email}`,
      }),
    });
    await response.text();
  } catch (err) {
  }
};

export const saveEmailId = (email) => async (dispatch, getState) => {
  try {
    dispatch({
      type: "SAVE_EMAIL_ID",
      payload: email,
    });
  } catch (err) {
  }
};
